import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'

// Contexts
import { CalendarContext } from '../../context/CalendarContext'

// Internal components
import Svg from '../Svg/Svg'
import Button from '../Button/Button'

const CalendarMenu = (props) => {
  const { menu, modifiers, cardRef } = props
  const [menuOpen, setMenuOpen] = useState(false)
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''
  const calendarContext = useContext(CalendarContext)

  useEffect(() => {
    // closes the menu if it's still open when the overlay is clicked.
    if (menuOpen && !calendarContext.showOverlay) setMenuOpen(false)
  }, [calendarContext.showOverlay])

  useEffect(() => {
    // makes the overlay visible when the menu opens and adds the 'has-menu' class to the opened menu.
    const cardRefClassList = cardRef?.current?.classList
    calendarContext.setShowOverlay(menuOpen)
    menuOpen ? cardRefClassList.add('has-menu') : cardRefClassList.remove('has-menu')
  }, [menuOpen])

  return (
    <div className={`CalendarMenu${modifierClasses}${menuOpen ? ' is-open' : ''}`}>
      <div className="CalendarMenu-inner">
        <div className="CalendarMenu-trigger" onClick={() => setMenuOpen(!menuOpen)}>
          <Svg id="icon-kebabmenu" modifiers={['CalendarMenu-triggerIcon']} />
        </div>
        <div className="CalendarMenu-list">
          {menu.map((menuItem, index) => {
            return (
              <div className="CalendarMenu-option" key={`CalendarMenu-option--${index}`}>
                <Button
                  label={menuItem?.label}
                  onClick={() => setMenuOpen(!menuOpen)}
                  modal={menuItem.modal}
                  modifiers={['Button--calendarMenu']}
                  inlineIcon={{ id: 'icon-chevron-right' }}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

CalendarMenu.propTypes = {
  cardRef: PropTypes.object,
  menu: PropTypes.any,
  modifiers: PropTypes.array
}

export default CalendarMenu
